/*  Image is based on "group" by Gregory Cresnar - https://thenounproject.com/icon/group-6249530 */

const Logo: React.FC<{ }> = ({  }) => {
    return (
        <svg viewBox="0 0 65 65">
            <path
                d="m 50.523944,4.4757162 a 13.07,13.07 0 0 0 -11.73,7.4299998 l -0.27,0.57 h -12 l -0.27,-0.57 a 13,13 0 1 0 -11.73,18.57 c 0.27,0 0.54,0 0.8,0 l 0.72,-0.05 6,9.36 -0.36,0.54 a 13,13 0 1 0 21.65,0 l -0.36,-0.54 6,-9.36 0.72,0.05 c 0.27,0 0.53,0 0.8,0 a 13,13 0 0 0 0,-25.9999998 z m -36,19.9999998 a 7,7 0 1 1 7,-7 7,7 0 0 1 -7,7 z m 18,30 a 7,7 0 1 1 7,-7 7,7 0 0 1 -7,7 z m 5.84,-18.64 -0.77,-0.36 a 13,13 0 0 0 -10.14,0 l -0.78,0.33 -4.87,-7.58 0.72,-0.56 a 12.93,12.93 0 0 0 4.85,-8.37 l 0.15,-0.82 h 10 l 0.12,0.86 a 12.93,12.93 0 0 0 4.88,8.36 l 0.72,0.56 z m 12.16,-11.36 a 7,7 0 1 1 7,-7 7,7 0 0 1 -7,7 z"/>
        </svg>
    );
};

export default Logo;